const {h, render, Component} = require('preact')
const {route} = require('preact-router')
const queryString = require('qs');

const SupportAPIHelper = require('../../../../../../support/frontend/helpers/API')
const DealImage = require('./deal_image')
const DetailTable = require('./detail_table')
const TransactionsContainer = require('../transactions/transactions')
const SSAButtons = require('../../self_service_actions/gplus/ssa_buttons')
const SSALinks = require('../../self_service_actions/gplus/ssa_links')
const ContextualSearch = require('../../search/contextual_search_bar')
const ContextualArticles = require('../../search/contextual_articles')
const ContactChannel = require('../../contact_us/contact_channels')
const SpinnerView = require('../../../views/common/spinner')
const ErrorView = require('../../main/error')
const Helper = require('../../../../helper')

class ClaimSummary extends Component {
  constructor(props) {
    super(props);
    this.createSummary = this.createSummary.bind(this);
    this.handleNeedHelpFromSearchResults = this.handleNeedHelpFromSearchResults.bind(this)
    this.getContactChannelParams = this.getContactChannelParams.bind(this)
    this.getContextualView = this.getContextualView.bind(this)
    this.getContactChannelsView = this.getContactChannelsView.bind(this)
    this.setState({'showContactChannels': false})
  }

  componentWillMount() {
    let dropDownCombinationItems = Groupon.Utils.getConfigFromDom().dropDownCombinationItems
    this.setState({dropDownCombinationItems: dropDownCombinationItems});

    this.setState({claimId: this.props.claimId});
    if (this.state.claimId) {
      this.setState({'isClaimDetailsLoading': true});
      let claimSummaryUrl = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/claims/${this.state.claimId}/summary`;
      let errorCb = () => {
        this.setState({claimDetails: null, 'isClaimDetailsLoading': false, 'isFailure': true});
      }
      let successCb = (response) => {
        if (response) {
          this.setState({claimDetails: response, 'isClaimDetailsLoading': false});
        }
      }
      SupportAPIHelper.get(claimSummaryUrl, null, successCb, errorCb, false);
    }
  }

  showContextualArticlesExperience() {
    return Groupon.Utils.getConfigFromDom().showContextualArticlesExperience;
  }

  componentDidMount() {
    let inbentaSessionToken = sessionStorage.getItem('inbentaSessionKey')
    if (inbentaSessionToken === null && inbentaSessionToken === undefined) {
      Helper.createSession();
    }
  }

  getContactChannelParams() {
    let resultParams = queryString.parse(this.props);
    let params = {};
    let specificTransaction = {}
    let noCashbackFound = {}
    let dropDownCombination = this.state.dropDownCombinationItems.dropDownCombination
    if (dropDownCombination) {
      specificTransaction = dropDownCombination.specificTransaction
      noCashbackFound = dropDownCombination.noCashbackFound
    }
    if (this.props.selectedInbentaResult) {
      params = queryString.parse(this.props.selectedInbentaResult);
    }
    else if (this.state.claimDetails && this.state.claimId) {
      params.selectedItem = this.state.claimDetails;
      if (this.state.selectedInbentaResult) {
        params = this.state.selectedInbentaResult;
        params.selectedItem = this.state.claimDetails;
      }
      else if (resultParams.selectedInbentaResult) {
        params = resultParams.selectedInbentaResult
        params.selectedItem = this.state.claimDetails;
      }
      else if (this.props.noCashback) {
        params.dropdownCategory = specificTransaction.dropdown_category
        params.dropdownSubcategory = noCashbackFound.dropdown_subcategory
        params.title = noCashbackFound.dropdown_title

      } else if (this.props.transaction_id) {
        params.dropdownCategory = specificTransaction.dropdown_category
        params.dropdownSubcategory = specificTransaction.dropdown_title
        params.title = specificTransaction.dropdown_title
        params.selectedItem.transaction_id = this.props.transaction_id
      }
      params.selectedItem.claim_id = this.state.claimId;
    }
    return params;
  }

  handleNeedHelpFromSearchResults(selectedInbentaResult) {
    this.setState({
      'selectedInbentaResult': selectedInbentaResult,
      'showContactChannels': true
    })
    route(`/customer_support/web/gplus/contact_channels?claim_id=${this.state.claimId}`);
  }

  getSSAButtonsView(details) {
    if (this.props.pageType == 'contextual') {
      return (
        <SSAButtons claimDetails={details}/>
      )
    }
  }

  getContextualView() {
    if (this.props.pageType == 'contextual') {
      if (this.state.claimDetails) {
        if (this.showContextualArticlesExperience()) {
          return (<ContextualArticles inbentaParams={this.state.claimDetails.inbentaParams}
                                     handleNeedHelpFromSearchResults={this.handleNeedHelpFromSearchResults}
                                      claimId={this.state.claimId}/>
          )
        }
        else {
          return (
              <ContextualSearch
                  inbentaParams={this.state.claimDetails.inbentaParams}
                  handleNeedHelpFromSearchResults={this.handleNeedHelpFromSearchResults}
              />)
        }
      }
    }
  }

  getContactChannelsView() {
    if (this.props.pageType == 'contact_channels') {
      if (this.state.showContactChannels || this.props.showContactChannels || this.props.showContactChannelsFromContextualBar)
        return <ContactChannel contactChannelParams={this.getContactChannelParams()}/>
    }
  }

  getTransactionsView() {
    if (this.props.pageType == 'transactions') {
      if (this.state.claimDetails)
        return (
          <TransactionsContainer claimDetails={this.state.claimDetails}/>
        )
    }
  }

  createSummary() {
    if (this.state.isClaimDetailsLoading)
      return (<SpinnerView/>)
    if (this.state.isFailure)
      return (<ErrorView/>)

    let summary = null
    let details = this.state.claimDetails
    if (details) {
      summary =
        <div class="twelve columns order-summary">
          <div class="row">
            <div class="three columns first-section">
              <DealImage dealDetails={details}/>
              <SSALinks claimDetails={details}/>
            </div>
            <div class="six columns second-section">
              <DetailTable claimDetails={details}/>
            </div>
            <div className="three columns third-section">
              {this.getSSAButtonsView(details)}
            </div>
          </div>
          {this.getContextualView()}
          {this.getTransactionsView()}
          {this.getContactChannelsView()}
        </div>
    }
    return summary;
  }

  render() {
    return (
      <section className="main row cs_support_header" id="contact-us-body-content">
        <div className="twelve columns">
          <section className="module">
            <div className="module-body contact-us">
              <div className="row">
                <div id="help-wizard" class="help-wizard" style="display: block;">
                  <div class="help-wizard-content">
                    {this.createSummary()}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    );
  }
}

module.exports = ClaimSummary
